import { SET_QUEUE_PLACEMENT } from '../../actions/common';

export default function queuePlacement(state, action) {
  const initialState = {};
  const newState = Object.assign({}, state);

  switch (action.type) {
    case SET_QUEUE_PLACEMENT:
      newState[action.resultId] = {
        account: action.account,
        queue: action.queue,
      };
      return newState;

    default:
      if (state === undefined) {
        return initialState;
      }
      return state;
  }
}
